/**
 * created by yxy
 *
 */

/**
 * 分类组件
 */
import React, {Component} from 'react';
import  UploadWall from '../../../../../components/upload/UploadWall'
import ChunkUpload from '../../../../../components/upload/ChunkUpload';
import {FILE_TYPE, PIC_TYPE, VIDEO_TYPE, AUDIO_TYPE, ATTCHMENT_TYPE} from '../../../../../constants';
import { Modal,message} from 'antd';
import PropTypes from "prop-types";

import {FileCountLimiter} from "../../../../../components/upload/FileCountLimiter";

export default class UpLoad extends Component {
    // 默认属性
    static defaultProps = {
        fileList:[],
        type:1,
        updateFileList:()=>{},
        imgHandleChange:()=>{

        },
    };
    // 静态类型分析
    static propTypes = {
        fileList:PropTypes.array.isRequired,//选择文件的数组
        imgHandleChange:PropTypes.func.isRequired,//选择图片
        type:PropTypes.number.isRequired,//选择文件上传文件类型
    };
    constructor(props) {
        super(props);
        this.state = {
            previewVisible:false,
            type:'',
            Collection:true,

        };

    }



    limiter = (()=>{
        let uploadSyncMaxCount = window.sysConfig && window.sysConfig.getValueByKey && window.sysConfig.getValueByKey("upload.sync.max.count", "5");//默认5个并发

        return new FileCountLimiter(parseInt(uploadSyncMaxCount));
    })();

    render() {

        let accept, listType;
        switch (this.props.type) {
            case "1":
                accept = "." + [...PIC_TYPE,].join(",.");
                listType = "picture-card";
                break;
            case "2":
                accept = "." + [...VIDEO_TYPE].join(",.");
                listType = "picture-card";
                break;
            case "3":
                accept = "." + [...FILE_TYPE].join(",.");
                listType = "list";
                break;
        }
        return (

            <div>
                <UploadWall
                    accept={accept}
                    multiple={true}
                    action={"/cm-sites-" + process.env.REACT_APP_NAME + "/index/uploadFile"}
                    listType={listType}
                    fileList={this.props.fileList}
                    customRequest={new ChunkUpload({
                        checkFileURL: "/cm-sites-storage/fileCheckUrl",
                        checkChunkURL: "/cm-sites-storage/checkChunk",
                        uploadChunkURL: "/cm-sites-storage/uploadChunks",
                        chunkUploadOverURL: "/cm-sites-storage/chunkUploadOver",
                        mergeChunksURL: "/cm-sites-storage/mergeChunks",
                    }).start}
                    icons={(() => {
                        let res = ["delete", "eye"];
                        return res;
                    })()}
                    reUpload={(uid) => {
                        this.limiter.retry(uid).then(() => {
                            message.success("已成功加入到上传队列中，请稍后");
                        }).catch(() => {
                            message.error("未获取到该文件，等待所有文件上传完成后，再关闭页面，重新选择上传");
                        });
                    }}
                    playToEys={true} // 将视频的播放转入查看功能
                    onChange={this.props.imgHandleChange}
                    onRemove={this.fileRemove}
                    onPreview={this.handlePreview}
                    beforeUpload={this.handleBeforeUploadZip}
                    uploadBtnName={""}
                    // onPlay={this.handlePreview}
                    showUploadBtn={true}
                    // onDownload={(file) => {
                    //     if (file.path.indexOf("?") === -1) {
                    //         window.location.href = file.path + "?download=1";
                    //     } else {
                    //         window.location.href = file.path + "&download=1";
                    //     }
                    // }}
                    style={{padding: "0px"}}
                >
                </UploadWall>


            </div>


        );
    }

}
